
import React from 'react';
import { Container, Box, Typography, Accordion, AccordionSummary, AccordionDetails, Stack } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const defaultFaqs = [
    { question: 'What regions do you deliver to?', answer: 'We currently deliver to all major metropolitan areas within the state. We are actively expanding our delivery network, so please check back for updates on new regions.' },
    { question: 'How do I place an order?', answer: 'Once you register for an account and are approved, you can log in to our customer portal. From there, you can browse our product catalog, select quantities, and schedule your delivery.' },
    { question: 'What are your quality standards?', answer: 'We pride ourselves on sourcing only the freshest, Grade A produce from trusted local and national farms. Every item is inspected for quality and freshness before it leaves our facility.' },
    { question: 'Is there a minimum order requirement?', answer: 'Yes, there is a minimum order value for delivery. This amount varies by region. You can find the specific minimum for your area in your customer portal after logging in.' },
];

function FaqPage() {
    let faqs = defaultFaqs;
    try {
        if (process.env.REACT_APP_FAQS) {
            faqs = JSON.parse(process.env.REACT_APP_FAQS);
        }
    } catch (e) {
        console.error("Failed to parse REACT_APP_FAQS", e);
    }

    return (
        <Box sx={{ py: 8, bgcolor: 'background.paper', minHeight: '80vh' }}>
            <Container maxWidth="md">
                <Typography variant="h3" component="h1" textAlign="center" fontWeight={700} color="text.primary" gutterBottom sx={{ mb: 6 }}>Frequently Asked Questions</Typography>
                <Stack spacing={2}>
                    {faqs.map((faq, index) => (
                        <Accordion key={index} sx={{ boxShadow: '0 2px 10px -5px rgba(0,0,0,0.1)', '&:before': { display: 'none' } }}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={`panel${index}-content`} id={`panel${index}-header`} sx={{ '& .MuiAccordionSummary-content': { fontWeight: 'medium' } }}>
                                <Typography variant="h6" component="p">{faq.question}</Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ color: 'text.secondary' }}>
                                <Typography>{faq.answer}</Typography>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </Stack>
            </Container>
        </Box>
    );
}

export default FaqPage;
